import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Statistics(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Statistics</h2>
                <li>
                    <Link to={`${url}/tendencies`}>Central Tendencies</Link>
                </li>
                <li>
                    <Link to={`${url}/permutations`}>Permutations and Combinations</Link>
                </li>
                <li>
                    <Link to={`${url}/probability`}>Laws of Probability</Link>
                </li>
               <li>
                    <Link to={`${url}/distributions`}>Distributions</Link>
                </li> 
                   <li>
                    <Link to={`${url}/statisticalinference`}>Statistical Inference</Link>
                </li>      
                      <li>
                    <Link to={`${url}/regressionanalysis`}>Regression Analysis</Link>
                </li>       
                      <li>
                    <Link to={`${url}/erroranalysis`}>Error Analysis</Link>
                </li>          
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Statistics; 